// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 11203-员工新增 POST /web/v1/staff/add */
export async function addStaff(
  body: API.SwimStaffAddVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11205-员工删除 POST /web/v1/staff/delete */
export async function deleteStaff(
  body: API.SwimStaffDeleteVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11202-员工详情查询 POST /web/v1/staff/detail */
export async function getStaffDetail(
  body: API.SwimStaffDetailQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOSwimStaffDetailVo>('/web/v1/staff/detail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11201-员工列表查询 POST /web/v1/staff/list */
export async function getStaffList(
  body: API.SwimStaffListQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimStaffListVo>(
    '/web/v1/staff/list',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 11208-员工登录 POST /web/v1/staff/login */
export async function staffLogin(
  body: API.SwimStaffLoginReqVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOSwimStaffLoginVo>('/web/v1/staff/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11212-员工退出登录 POST /web/v1/staff/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 11210-管理员重置员工密码 POST /web/v1/staff/password/reset */
export async function resetStaffPassword(
  body: API.SwimStaffPasswordResetVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/password/reset', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11209-员工自行修改密码 POST /web/v1/staff/password/update */
export async function updateStaffPassword(
  body: API.SwimStaffPasswordUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/password/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11211-修改密码 POST /web/v1/staff/password/update/plat */
export async function updateStaffPasswordPlat(
  body: API.SwimPlatStaffPasswordUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/password/update/plat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11207-员工角色分配 POST /web/v1/staff/role/assign */
export async function assignStaffRole(
  body: API.SwimStaffRoleAssignVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/role/assign', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11206-员工状态变更 POST /web/v1/staff/status */
export async function updateStaffStatus(
  body: API.SwimStaffStatusUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11204-员工修改 POST /web/v1/staff/update */
export async function updateStaff(
  body: API.SwimStaffUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/staff/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
